import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

interface Props {
  number: string;
}

const EmptyList: React.FC<Props> = ({ number }) => {
  const { t } = useTranslation();
  return (
    // <td colSpan={8}>
    <td colSpan={6}>
      <div className="m-3 mt-5 d-flex justify-content-center">
        <div className="circle-base-big">
          <div className="circle-inner">
            <FontAwesomeIcon icon="file-word" />
          </div>
        </div>
      </div>
      <div className="m-3 d-flex justify-content-center">
        <h1 className="page-title inner-title">{t('operationNoActionPlan', { number })}</h1>
      </div>
    </td>
  );
};

export default EmptyList;
